import React from "react";
import { FaMobile, FaHome, FaBuilding } from "react-icons/fa";

const PhoneInput = ({
  value,
  onChange,
  type,
  onTypeChange,
  error,
  className = "",
}) => {
  const types = [
    { id: "Mobile", icon: FaMobile, label: "Mobile" },
    { id: "Home", icon: FaHome, label: "Home" },
    { id: "Work", icon: FaBuilding, label: "Work" },
  ];

  return (
    <div className="relative flex items-center">
      <input
        type="text"
        value={value}
        onChange={onChange}
        className={`${className} pr-24 w-full`} // Add padding for icons
      />
      <div className="absolute right-2 flex space-x-2">
        {types.map(({ id, icon: Icon, label }) => (
          <button
            key={id}
            type="button"
            onClick={() => onTypeChange(id)}
            className={`p-1 rounded-full hover:bg-gray-100 dark:hover:bg-gray-800 transition-all hover:scale-110
              ${type?.toUpperCase() === id.toUpperCase() ? "text-blue-600" : "text-gray-400"}`}
            title={label}
          >
            <Icon className="w-4 h-4" />
          </button>
        ))}
      </div>
    </div>
  );
};

export default PhoneInput;
